export enum ZitadelRoleEnum {
  COMMUNITY_1 = 'community-1', // xeoStarter
  COMMUNITY_2 = 'community-2', // xeoIntegrator
  COMMUNITY_3 = 'community-3',
  STRIPE_1 = 'stripe-1', // xeoEssentials
  STRIPE_2 = 'stripe-2', //xeoPriority
  STRIPE_3 = 'stripe-3',
  FF_PAYMENTS = 'ff-payments',
  M_ADMIN = 'm-admin',
  COMMUNITY_EXTENSION_1 = 'community-extension-1', // xeoRVT
  COMMUNITY_EXTENSION_2 = 'community-extension-2',
  COMMUNITY_EXTENSION_3 = 'community-extension-3',
  STRIPE_EXTENSION_1 = 'stripe-extension-1', // xeoRVT
  STRIPE_EXTENSION_2 = 'stripe-extension-2',
  STRIPE_EXTENSION_3 = 'stripe-extension-3',
}

export type ZitadelRole = `${ZitadelRoleEnum}`;
export type ZitadelRoleTuple = [ZitadelRole, ...ZitadelRole[]];
